import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';


@Injectable()
export class DateService {

	constructor(private datePipe: DatePipe) {
		return;
	}

	public roundDateToNearestMinute(value: Date): Date {
		if (value.getSeconds() < 30) {
			// Round minute down
			value.setMilliseconds(0);
			value.setSeconds(0);
		}
		else {
			// Round minute up
			const MillisPerSecond = 1000;
			value = new Date(value.getTime() + MillisPerSecond);
			value.setMilliseconds(0);
			value.setSeconds(0);
		}

		return value;
	}

	public formatDate(date: string | Date): string {
		return this.datePipe.transform(date, 'MM/dd/yyyy');
	}

	public formatDateHm(date: string | Date): string {
		try {
			return this.datePipe.transform(date, 'MM/dd/yyyy HH:mm');
		}
		catch (ex) {
			console.error("Invalid date: " + date);
			return "";
		}
	}

	public formatDateHms(date: string | Date): string {
		return this.datePipe.transform(date, 'MM/dd/yyyy HH:mm:ss');
	}

	public formatTimeHm(date: string | Date): string {
		return this.datePipe.transform(date, 'HH:mm');
	}

}
